import { Divider } from "@mui/material";
import Flex from "../../../../../components/Flex";
import { useFaxOutgoingList } from "../../../../../queries/communication/fax-integration/use-fax-outgoing-list";
import { getXtenantId } from "../../../../../utils/utils";
import FaxSideSection from "./FaxSideSection";
import { useState } from "react";
import FaxHeader from "./FaxHeader";
import { useGetFaxOutgoingByUuid } from "../../../../../queries/communication/fax-integration/use-get-fax-outgoing-by-uuid";

const OutgoingFax = () => {
  const [searchKey, setSearchKey] = useState("");
  const [activeTab, setActiveTab] = useState("all");
  const [selectedFax, setSelectedFax] = useState<any>(null);
  const { data: outgoingFaxList } = useFaxOutgoingList({
    pagination: { page: 0, pageSize: 50 },
    gridSorting: [],
    xTENANTID: getXtenantId(),
    searchString: searchKey,
    active: true,
    archive: false,
  });
  const { data: faxData } = useGetFaxOutgoingByUuid({
    faxOutgoingUuid: selectedFax?.uuid,
    enabled: !!selectedFax?.uuid,
  });
  return (
    <Flex height={"calc(100svh - 11.5rem)"} width={"100%"}>
      <Divider sx={{ width: "1px", backgroundColor: "gray" }} />

      <Flex height={"100%"} width={"100%"}>
        <Flex height="calc(100svh - 11.5rem)" width="100%">
          <FaxSideSection
            faxItems={outgoingFaxList?.data?.content ?? []}
            searchKey={searchKey}
            activeTab={activeTab}
            setSearchKey={setSearchKey}
            setActiveTab={setActiveTab}
            showTabs={false}
            setSelectedFax={setSelectedFax}
            selectedFax={selectedFax}
          />
          <Flex flex={1} p={1.2} height="calc(100svh - 11.5rem)">
            {selectedFax && <FaxHeader faxData={faxData?.data} />}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default OutgoingFax;
